<template>
    <div id="app" :style="{minWidth: min_width}">
        <router-view/>
    </div>
</template>
<script>
    import {isMobile} from "@/api/order";

    export default {
        data() {
            return {
                min_width: "1380px",
            }
        },
        mounted() {
            this.$store.dispatch('app/init')
        },
        created() {
            if (isMobile()) {
                this.min_width = "600px"

                import("@/styles/mobile.scss")
            } else {
                import("@/styles/pc.scss")
            }
        }
    };
</script>

<style lang="scss">
    @import "@/styles/common.scss";
    html,
    body {
        margin: 0;
        padding: 0;
        background: $gray;
        width: 100%;
        height: 100%;
        position: relative;
        overflow-y: hidden;
    }

    #app {
        font-family: "Avenir", Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        height: 100%;
    }
</style>
